module.exports = __webpack_public_path__ + "img/paySuccess.06bfd2b7.png";